import React, {
  useState,
  createContext,
  useContext,
  useEffect,
} from "react";

const IFPRSGlobalContext = createContext(null);

export function IFPRSGlobalProvider({ dbLayerList, children }) {

  //----------------
  // Context Variables
  //----------------
  const [alertMessageObj,setAlertMessageObj] = useState({
    title: "",
    message: "",
    severity: "", // "error", "warning", "info", "success"
    child: null, // Used for arbitrary returns such as a Typography component
    callback: null // Used for a callback function to be executed after the alert is closed
  });
  const showAlertPopup = alertMessageObj.severity && alertMessageObj.severity !== "";
  const [showGlobalLoader,setShowGlobalLoader] = useState(false);
  const [showListCardLoader,setShowListCardLoader] = useState(false);
  const [showMapLoader,setShowMapLoader] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [, setLayerList] = useState([]);
  const [treatmentQueryError,setTreatmentQueryError] = useState(false);
  const [projectQueryError, setProjectQueryError] = useState(false);
  const [activityQueryError,setActivityQueryError] = useState(false);
  const [actualTreatmentQueryError,setActualTreatmentQueryError] = useState(false);
  const [actualActivityQueryError,setActualActivityQueryError] = useState(false);
  const [treatmentCount, setTreatmentCount] = useState<number>(0);
  const [activityCount, setActivityCount] = useState(0);
  const [actualTreatmentCount, setActualTreatmentCount] = useState(0);
  const [actualActivityCount, setActualActivityCount] = useState(0);
  const [treatmentCountQueryError,setTreatmentCountQueryError] = useState(false);
  const [activityCountQueryError,setActivityCountQueryError] = useState(false);
  const [actualTreatmentCountQueryError,setActualTreatmentCountQueryError] = useState(false);
  const [actualActivityCountQueryError,setActualActivityCountQueryError] = useState(false);
  const [isTreatmentCountQuerying, setIsTreatmentCountQuerying] = useState<boolean>(false);
  const [isActivityCountQuerying, setIsActivityCountQuerying] = useState(false);
  const [isActualTreatmentCountQuerying, setIsActualTreatmentCountQuerying] = useState(false);
  const [isActualActivityCountQuerying, setIsActualActivityCountQuerying] = useState(false);
  const [fundingDepartmentOptions, setFundingDepartmentOptions] = useState([]);
  const [fundingAgencyOptions, setFundingAgencyOptions] = useState([]);
  const [fundingRegionOptions, setFundingRegionOptions] = useState([]);
  const [fundingUnitOptions, setFundingUnitOptions] = useState([]);
  const [fundingSubUnitOptions, setFundingSubUnitOptions] = useState([]);
  const [fundingTribeOptions, setFundingTribeOptions] = useState([]);
  const [fundingUnitTypeOptions, setFundingUnitTypeOptions] = useState([]);
  const [polygonListCount, setPolygonListCount] = useState(25)
  const [lineListCount, setLineListCount] = useState(25)
  const [pointListCount, setPointListCount] = useState(25)
  const [sortByValue, setSortByValue] = useState("");
  const [projectSortByValue, setProjectSortByValue] = useState(`Name ASC`);
  const [filterListOpen, setFilterListOpen] = useState(false);
  const [wbsIDValues, setWbsIDValues] = useState([]);
  const [congressDistValues, setCongressDistValues] = useState([]);
  const [countyOptions, setCountyOptions] = useState([]);
  const [nameValueOptions,setNameValueOptions] = useState([]);
  const [actionCategoryAssociations, setActionCategoryAssociations] = useState([]);


  //----------------
  // Effect Hooks
  //----------------

  // useEffect(() => {
  //   let isCurrent = true;
  //   console.log("Loading IFPRS Globals");

  //   return () => {
  //     isCurrent = false;
  //   };
  // }, []);

  useEffect(() => {
    if(dbLayerList?.length > 0)
    {
      setLayerList(dbLayerList);
    }
  }, [dbLayerList]);



  //----------------
  // Context values, variables/methods must be included to be accessible
  //----------------

  const context = {
    alertMessageObj, setAlertMessageObj, showAlertPopup,
    showGlobalLoader, setShowGlobalLoader,
    showListCardLoader, setShowListCardLoader,
    showMapLoader, setShowMapLoader,
    statusOptions, setStatusOptions,
    treatmentCount, setTreatmentCount, treatmentQueryError, setTreatmentQueryError,
    activityCount, setActivityCount, activityQueryError, setActivityQueryError,
    actualTreatmentCount, setActualTreatmentCount, actualTreatmentQueryError, setActualTreatmentQueryError,
    actualActivityCount, setActualActivityCount, actualActivityQueryError, setActualActivityQueryError,
    polygonListCount, setPolygonListCount,
    lineListCount, setLineListCount,
    pointListCount, setPointListCount,
    sortByValue, setSortByValue,
    projectSortByValue, setProjectSortByValue,
    filterListOpen, setFilterListOpen,
    treatmentCountQueryError,setTreatmentCountQueryError, activityCountQueryError,setActivityCountQueryError,
    actualTreatmentCountQueryError,setActualTreatmentCountQueryError, actualActivityCountQueryError,setActualActivityCountQueryError,
    isTreatmentCountQuerying, setIsTreatmentCountQuerying, isActivityCountQuerying, setIsActivityCountQuerying, 
    isActualTreatmentCountQuerying, setIsActualTreatmentCountQuerying, isActualActivityCountQuerying, setIsActualActivityCountQuerying,
    fundingDepartmentOptions, setFundingDepartmentOptions, fundingAgencyOptions, setFundingAgencyOptions, 
    fundingRegionOptions, setFundingRegionOptions, fundingUnitOptions, setFundingUnitOptions, 
    fundingSubUnitOptions, setFundingSubUnitOptions, fundingTribeOptions, setFundingTribeOptions, 
    fundingUnitTypeOptions, setFundingUnitTypeOptions, wbsIDValues, setWbsIDValues,
    congressDistValues, setCongressDistValues, countyOptions, setCountyOptions,
    nameValueOptions, setNameValueOptions, projectQueryError, setProjectQueryError, actionCategoryAssociations, setActionCategoryAssociations
  };

  return <IFPRSGlobalContext.Provider value={context} children={children} />;
}

export function useIFPRSGlobalContext() {
  const context = useContext(IFPRSGlobalContext);
  if (!context) {
    throw Error(
      "Use of `useIFPRSGlobalContext` is outside of `IFPRSGlobalProvider`"
    );
  }
  return context || {};
}
